// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"179f5bc0","598":"70aa597b","703":"4d0b6aef","787":"b6c103e7"}[chunkId] + ".chunk.js";
};